/*! For license information please see saros10r_main.js.LICENSE.txt */ ! function() {
    var e = {
            "./src/js/main.js": function(e, s, t) {
                "use strict";
                var i = t("./src/widgets/debug.js"),
                    n = t("./src/widgets/gsap-sequence.js"),
                    o = t("jquery");

                function c(e) {
                    return c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
                    }, c(e)
                }

                function r(e, s, t) {
                    var i;
                    return i = function(e, s) {
                        if ("object" != c(e) || !e) return e;
                        var t = e[Symbol.toPrimitive];
                        if (void 0 !== t) {
                            var i = t.call(e, s || "default");
                            if ("object" != c(i)) return i;
                            throw new TypeError("@@toPrimitive must return a primitive value.")
                        }
                        return ("string" === s ? String : Number)(e)
                    }(s, "string"), (s = "symbol" == c(i) ? i : i + "") in e ? Object.defineProperty(e, s, {
                        value: t,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[s] = t, e
                }(0, i.debugfunction)();
                var a = document.documentElement.clientHeight || window.innerHeight,
                    p = (document.documentElement.clientWidth || window.innerWidth) < 750;
                window.addEventListener("scroll", (function(e) {
                    0 != window.scrollY && window.scrollY
                }));
                var g, u, _, l = o(window).scrollTop();

                function m(e) {
                    o(e).each((function() {
                        gsap.set(o(this), {
                            opacity: 0,
                            y: 60
                        }), gsap.fromTo(o(this), {
                            y: 60,
                            opacity: 0
                        }, {
                            y: 0,
                            opacity: 1,
                            duration: .5,
                            ease: "power2.easeOut",
                            immediateRender: !0,
                            scrollTrigger: {
                                trigger: o(this),
                                start: "top bottom-=15%",
                                end: "top+=50px bottom-=" + (p ? "15%" : "10%"),
                                invalidateOnRefresh: !0,
                                toggleActions: "play none reverse none"
                            },
                            delay: Number(o(this).attr("delay")) || 0
                        })
                    }))
                }

                function d(e) {
                    o(e).each((function() {
                        var e = o(this).attr("start") || "30%",
                            s = gsap.timeline({
                                scrollTrigger: {
                                    trigger: o(this),
                                    start: "top bottom-=" + (p ? "15%" : e),
                                    end: "top+=50px bottom-=" + (p ? "15%" : "10%"),
                                    invalidateOnRefresh: !0,
                                    toggleActions: "play none reverse none",
                                    id: "s-uplist"
                                },
                                onComplete: function() {
                                    ScrollTrigger.refresh()
                                }
                            });
                        o(this).find(o.CN(".fadein-up-list")).each((function(e, t) {
                            gsap.set(o(t), {
                                opacity: 0,
                                y: 100
                            }), s.fromTo(o(t), {
                                y: 100,
                                opacity: 0
                            }, {
                                y: 0,
                                opacity: 1,
                                duration: .5,
                                ease: "power0.easeOut",
                                immediateRender: !0
                            }, "<40%")
                        }))
                    }))
                }

                function f(e) {
                    var s = {
                        duration: .6,
                        delay: .1,
                        ease: "power1.inout"
                    };
                    e.forEach((function(e, t) {
                        gsap.timeline({
                            yoyo: !0,
                            defaults: s,
                            scrollTrigger: {
                                trigger: e,
                                start: "top bottom-=25%",
                                end: "top bottom-=25%",
                                invalidateOnRefresh: !0,
                                toggleActions: "play none resume reverse"
                            }
                        }).fromTo(e, {
                            opacity: 0,
                            width: 0
                        }, {
                            opacity: 1,
                            width: "100%",
                            immediateRender: !0
                        }, ">")
                    }))
                }

                function w(e) {
                    o(o.CN(".section-forth .btn")).on("click", (function() {
                        o("body").addClass("".concat("saros10r_", "has-popup")), o(o.CN(".section-forth-expand")).addClass("".concat("saros10r_", "active")), o(o.CN(".section-forth-expand .scroll-wrapper")).scrollTop(0), o(o.CN(".section-forth-expand .box-btn")).removeClass("".concat("saros10r_", "hide"))
                    })), o(o.CN(".section-forth-expand .box-btn")).on("click", (function() {
                        o(o.CN(".section-forth-expand .page3-container")).addClass("".concat("saros10r_", "active")), o(o.CN(".section-forth-expand .box-btn")).addClass("".concat("saros10r_", "hide"))
                    })), o(o.CN(".section-forth-expand .close-btn")).on("click", (function() {
                        o("body").removeClass("".concat("saros10r_", "has-popup")), o(o.CN(".section-forth-expand")).removeClass("".concat("saros10r_", "active")), o(o.CN(".section-forth-expand .page3-container")).removeClass("".concat("saros10r_", "active")), o(o.CN(".section-forth-expand .box-btn")).removeClass("".concat("saros10r_", "hide"))
                    })), o(o.CN(".section-forth-expand ")).on("scroll", (function(e) {
                        var s = o(o.CN(".section-forth-expand .page-line")),
                            t = (document.querySelector(o.CN(".section-forth-expand .page2-content1")), document.querySelector(o.CN(".section-forth-expand .page2-content2")).getBoundingClientRect()),
                            i = (o(o.CN(".section-forth-expand .content-block")).css("margin-top"), o(this).innerHeight() - 60),
                            n = parseInt(i / 2);
                        parseInt(t.bottom) - n < n ? s.css({
                            opacity: 1,
                            transform: "scaleX(1)"
                        }) : s.css({
                            opacity: 0,
                            transform: "scaleX(0)"
                        })
                    }))
                }

                function v(e, s) {
                    e && (h(0, e, s, null), e.forEach((function(t, i) {
                        t.addEventListener("mouseenter", (function() {
                            h(i, e, s, null)
                        })), t.addEventListener("mouseleave", (function() {
                            this.classList.remove("saros10r_active"), this.querySelector("video").pause()
                        }))
                    })))
                }

                function b(e) {
                    p ? m(o.CN(".section-thirteenth .fadein-up-list")) : (d(o.CN(".section-thirteenth .container-fadein-up-list")), v(document.querySelectorAll(o.CN(".section-thirteenth .video-wrap-item")), o(o.CN(".section-thirteenth .video-wrap-item"))));
                    ! function(e) {
                        var s = !1,
                            t = new IntersectionObserver((function(i) {
                                i.forEach((function(i) {
                                    i.isIntersecting && i.intersectionRatio >= .5 && !s && (e.play().then((function() {
                                        console.log("视频播放成功")
                                    })).catch((function(e) {
                                        console.error("视频播放失败:", e)
                                    })), s = !0, t.unobserve(e))
                                }))
                            }), {
                                root: null,
                                rootMargin: "0px",
                                threshold: .5
                            });
                        t.observe(e)
                    }(document.querySelector(o.CN(".section-thirteenth .video-paly")))
                }

                function R(e) {
                    var s = o(o.CN(".section-fourteenth .tab-svg-item"));
                    s.attr("class", (function(e, s) {
                        if (!s) return "";
                        var t = new RegExp("\\b".concat("saros10r_active", "\\b"), "g");
                        return s.replace(t, "").trim()
                    })), s.eq(e).attr("class", (function(e, s) {
                        return (s ? s + " " : "") + "saros10r_active"
                    }))
                }

                function h(e, s, t) {
                    var i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
                    i && (i.removeClass("saros10r_active"), i.eq(e).addClass("saros10r_active")), t.removeClass("saros10r_active"), s.forEach((function(e, s) {
                        e.querySelector("video").pause()
                    })), t.eq(e).addClass("saros10r_active"), x(s[e].querySelector("video")).then((function() {})).catch((function(e) {}))
                }

                function x(e) {
                    return new Promise((function(s, t) {
                        e.paused ? e.play().then((function() {
                            s()
                        })).catch((function(e) {
                            t(e)
                        })) : s()
                    }))
                }

                function j() {
                    // m(o.CN(".section-sixteenth .fadein-up")),
                    //     function(e) {
                    //         var s = !1,
                    //             t = new IntersectionObserver((function(i) {
                    //                 i.forEach((function(i) {
                    //                     i.isIntersecting && i.intersectionRatio >= .5 && !s && (e.play().then((function() {
                    //                         console.log("视频播放成功")
                    //                     })).catch((function(e) {
                    //                         console.error("视频播放失败:", e)
                    //                     })), s = !0, t.unobserve(e))
                    //                 }))
                    //             }), {
                    //                 root: null,
                    //                 rootMargin: "0px",
                    //                 threshold: .5
                    //             });
                    //         t.observe(e)
                    //     }(
                    //         document.querySelector(o.CN(".section-sixteenth .video-paly"))
                    //     )
                }
                o(window).on("scroll", (function(e) {
                        var s = o(window).scrollTop();
                        s > l ? "down" : "up", l = s;
                        var t = null,
                            i = null,
                            n = window.pageYOffset || document.documentElement.scrollTop;
                        document.documentElement.offsetHeight, window.innerHeight;
                        if (o(o.CN(".product-container .section")).each((function(e, s) {
                                var c = o(s).data("section"),
                                    r = s.offsetTop,
                                    a = r + s.offsetHeight;
                                n >= r && n <= a && (t = c, i = o(s).find(o.CN(".video-auto")))
                            })), p) {
                            [1, 2, 6, 7, 10, 12, 13, 14, 15, 16, 23].includes(t) && i.each((function(e) {
                                x(o(this)).then((function() {
                                    console.log("视频正在播放")
                                })).catch((function(e) {
                                    console.error("播放视频时出错", e)
                                }))
                            }))
                        }
                    })), 
                    o(window).on("resize", (function(e) {})), o(document).ready((function() {})),
                    function(e) {
                        if (!p) {
                            var s = o.CN(".section-fifth .sticky"),
                                t = (parseInt(a - o(s).innerHeight()), new Array(51).fill().map((function(e, s) {
                                    return "".concat("//cdn.shopify.com/s/files/1/0078/9754/6842/", "files/").concat("saros10r_", "section5_ChaoBao_").concat(s, ".png")
                                }))),
                                i = (0, n.imageSequence)({
                                    urls: t,
                                    canvas: "#image-sequence5",
                                    clear: !0,
                                    objectFit: "contain"
                                });
                            gsap.timeline({
                                yoyo: !0,
                                scrollTrigger: {
                                    trigger: o(o.CN(".section-fifth .sticky-content")),
                                    start: "top top",
                                    end: "bottom bottom",
                                    scrub: !0
                                }
                            }).add(i)
                        }
                    }(), g = document.querySelector(o.CN(".section-ninth .box")), u = document.querySelector(o.CN(".section-ninth .box-invisible")), _ = document.querySelector(o.CN(".section-ninth .box-visible")), gsap.timeline({
                        yoyo: !0,
                        defaults: {
                            duration: 1.5,
                            delay: .3,
                            ease: "power1.inOut"
                        },
                        scrollTrigger: {
                            trigger: g,
                            start: "top center",
                            end: "top center",
                            toggleActions: "play play resume reverse",
                            scrub: !0
                        }
                    }).to(u, {
                        opacity: 0
                    }, ">").to(_, {
                        opacity: 1
                    }, ">"), window.onload = function() {
                        var e, s;
                        var sp_r = document.documentElement.clientWidth || window.innerWidth,
                            sp_a = sp_r < 750;

                        e = o.CN(".section-first .basemap"), s = o.CN(".section-first .fadein-up-title"), gsap.set(o(s), {
                                opacity: 0,
                                y: 400
                            }), p ? gsap.fromTo(o(s), {
                                y: 400,
                                opacity: 0
                            }, {
                                y: 0,
                                opacity: 1,
                                duration: .5,
                                ease: "power2.easeOut",
                                immediateRender: !0,
                                scrollTrigger: {
                                    trigger: e,
                                    start: "bottom-=50px bottom-=20%",
                                    end: "bottom+=100px bottom-=15%",
                                    invalidateOnRefresh: !0,
                                    toggleActions: "play resume resume reverse",
                                    id: "s1"
                                }
                            }, ">") : gsap.fromTo(o(s), {
                                y: 400,
                                opacity: 0
                            }, {
                                y: 0,
                                opacity: 1,
                                duration: .5,
                                ease: "power2.easeOut",
                                immediateRender: !0,
                                scrollTrigger: {
                                    trigger: e,
                                    start: "bottom-=50px bottom-=20%",
                                    end: "bottom+=150px bottom-=15%",
                                    invalidateOnRefresh: !0,
                                    toggleActions: "play resume resume reverse",
                                    id: "s1"
                                }
                            }, ">"), o(o.CN(".section-first video".concat(sp_a ? o.CN(".EQ-MOB") : o.CN(".EQ-PC")))).get(0).addEventListener("ended", (function() {
                                
                                $('.fv_area').addClass('active');
                                
                                o(o.CN(".section-first .kv-img".concat(sp_a ? o.CN(".EQ-MOB") : o.CN(".EQ-PC")))).css({
                                    opacity: 1
                                })
                            })), o(o.CN(".section-second .fadein-up")), p ? o(o.CN(".section-third .fadein-up-list")) : d(o.CN(".section-third .container-fadein-up-list")), o(o.CN(".section-third .box")).on("click", (function() {
                                var e = o(this).attr("id") + "-section";
                                o("html, body").animate({
                                    scrollTop: o("#" + e).offset().top
                                }, 1e3)
                            })), w(),
                            function() {
                                m(o.CN(".section-sixth .fadein-up"));
                                var e = document.querySelector(o.CN(".section-sixth .image-wrap-show")),
                                    s = (document.querySelector(o.CN(".section-sixth .img-dark")), document.querySelector(o.CN(".section-sixth .img-highlight")));
                                gsap.timeline({
                                    yoyo: !0,
                                    defaults: {
                                        duration: .5,
                                        delay: .3,
                                        ease: "power1.inOut"
                                    },
                                    scrollTrigger: {
                                        trigger: e,
                                        start: "top+=20% center",
                                        end: "center center",
                                        toggleActions: "play resume resume reverse",
                                        scrub: !0
                                    }
                                }).to(s, {
                                    opacity: 1
                                }, ">"), p ? m(o.CN(".section-sixth .fadein-up-list")) : (d(o.CN(".section-sixth .container-fadein-up-list")), v(document.querySelectorAll(o.CN(".section-sixth .video-wrap-item")), o(o.CN(".section-sixth .video-wrap-item"))))
                            }(),
                            function(e) {
                                var s = document.querySelector(o.CN(".section-seventh .content-title")),
                                    t = o.CN(".section-seventh .base-text-title span"),
                                    i = o.CN(".section-seventh .filter-wrap"),
                                    n = gsap.timeline({
                                        yoyo: !0,
                                        defaults: {
                                            duration: .5,
                                            delay: .2,
                                            ease: "power1.inout",
                                            immediateRender: !0
                                        },
                                        scrollTrigger: {
                                            trigger: s,
                                            start: "top bottom-=25%",
                                            end: "top+=150px bottom-=25%",
                                            toggleActions: "play resume resume reverse",
                                            id: "s7-timeline"
                                        }
                                    });
                                n.fromTo(o(t), {
                                    color: "#828282"
                                }, {
                                    color: "#fff",
                                    immediateRender: !1
                                }, 0), n.fromTo(o(i), {
                                    opacity: 0
                                }, {
                                    opacity: 1,
                                    immediateRender: !1
                                }, 0), f(document.querySelectorAll(o.CN(".section-seventh .list-item-line")))
                            }(),
                            function(e) {
                                var s = o(o.CN(".section-eighth .tab"));
                                if (s) {
                                    var t = new Swiper("#eighthSwiper", {
                                        grabCursor: !0,
                                        effect: "slide",
                                        speed: 600,
                                        easing: "ease-out",
                                        loop: !0,
                                        slidesPerView: "auto",
                                        a11y: {
                                            slideRole: "listitem"
                                        },
                                        autoplay: !1,
                                        navigation: {
                                            nextEl: "#eighthSwiperBtNext",
                                            prevEl: "#eighthSwiperBtPrev"
                                        },
                                        on: {
                                            slideChange: function() {
                                                var e = this.activeIndex % 5;
                                                o(o.CN(".section-eighth .tab")).removeClass("".concat("saros10r_", "active")), o(o.CN(".section-eighth .tab")).eq(e).addClass("".concat("saros10r_", "active"))
                                            }
                                        }
                                    });
                                    t.slideTo(0), s.on("click", (function() {
                                        o(this).addClass("".concat("saros10r_", "active")).siblings().removeClass("".concat("saros10r_", "active"));
                                        var e = o(this).index();
                                        t.slideTo(e)
                                    }))
                                }
                                p && m(o.CN(".section-eighth .fadein-up"))
                            }(),
                            function(e) {
                                if (p) m(o.CN(".section-tenth .fadein-up"));
                                else {
                                    var s = o.CN(".section-tenth .stick-wrapper"),
                                        t = o.CN(".section-tenth .stick-wrapper .stick-content-item:nth-of-type(1)"),
                                        i = o.CN(".section-tenth .stick-wrapper .stick-content-item:nth-of-type(1) .number-list-item-line"),
                                        n = o.CN(".section-tenth .stick-wrapper .stick-content-item:nth-of-type(2)"),
                                        c = o.CN(".section-tenth .stick-wrapper .stick-content-item:nth-of-type(2) .number-list-item-line"),
                                        r = o.CN(".section-tenth .stick-wrapper .page-bullet"),
                                        a = parseInt(o(o.CN(".section-tenth .stick-wrapper .stick-content")).css("padding-top"));
                                    o(t).addClass("".concat("saros10r_", "active")).css({
                                        "margin-top": 0
                                    }), o(r).find("span:nth-of-type(1)").addClass("".concat("saros10r_", "active")), f(document.querySelectorAll(o.CN(".section-tenth .number-list-item-line")));
                                    var g = gsap.timeline({
                                        scrollTrigger: {
                                            trigger: s,
                                            start: function() {
                                                return "top-=50 top"
                                            },
                                            end: function() {
                                                return "+=".concat(parseInt(innerHeight) - 50)
                                            },
                                            pin: !0,
                                            anticipatePin: 1,
                                            scrub: 1,
                                            onSnapComplete: function(e) {
                                                var s = e.progress,
                                                    t = e.direction,
                                                    i = e.isActive;
                                                console.log(s, t, i)
                                            },
                                            invalidateOnRefresh: !0,
                                            id: "s10"
                                        }
                                    });
                                    g.addLabel("step1-start").to(t, {
                                        duration: 1,
                                        onStart: function() {
                                            o(t).addClass("".concat("saros10r_", "active")).css({
                                                "margin-top": 0
                                            }), o(i).css({
                                                opacity: 1,
                                                transform: "scaleX(1)"
                                            }), o(r).find("span:nth-of-type(1)").addClass("".concat("saros10r_", "active")), o(r).find("span:nth-of-type(2)").removeClass("".concat("saros10r_", "active")), o(n).removeClass("".concat("saros10r_", "active")), o(c).css({
                                                opacity: 0,
                                                transform: "scaleX(0)"
                                            })
                                        },
                                        onReverseComplete: function() {
                                            o(t).css({
                                                "margin-top": a
                                            })
                                        }
                                    }).addLabel("step2-start").to(n, {
                                        duration: 1,
                                        onStart: function() {
                                            o(t).removeClass("".concat("saros10r_", "active")), o(i).css({
                                                opacity: 0,
                                                transform: "scaleX(0)"
                                            }), o(r).find("span:nth-of-type(1)").removeClass("".concat("saros10r_", "active")), o(r).find("span:nth-of-type(2)").addClass("".concat("saros10r_", "active")), o(n).addClass("".concat("saros10r_", "active")).css({
                                                "margin-top": 0
                                            }), o(c).css({
                                                opacity: 1,
                                                transform: "scaleX(1)"
                                            })
                                        },
                                        onReverseComplete: function() {
                                            o(t).addClass("".concat("saros10r_", "active")).css({
                                                "margin-top": 0
                                            }), o(i).css({
                                                opacity: 1,
                                                transform: "scaleX(1)"
                                            }), o(r).find("span:nth-of-type(1)").addClass("".concat("saros10r_", "active")), o(r).find("span:nth-of-type(2)").removeClass("".concat("saros10r_", "active")), o(n).removeClass("".concat("saros10r_", "active")), o(c).css({
                                                opacity: 0,
                                                transform: "scaleX(0)"
                                            })
                                        }
                                    })
                                }
                                var u = o.CN(".section-tenth .wheel-box");
                                gsap.set(o(u), {
                                    opacity: 0,
                                    y: 60
                                }), gsap.fromTo(o(u), {
                                    y: 60,
                                    opacity: 0
                                }, {
                                    y: 0,
                                    opacity: 1,
                                    duration: .5,
                                    ease: "power2.easeOut",
                                    immediateRender: !0,
                                    scrollTrigger: {
                                        trigger: o(u),
                                        start: "top bottom-=15%",
                                        end: "top+=50px bottom-=" + (p ? "15%" : "10%"),
                                        invalidateOnRefresh: !0,
                                        toggleActions: "play none reverse none",
                                        id: "s10-wheel"
                                    },
                                    delay: Number(o(u).attr("delay")) || 0
                                })
                            }(), p ? m(o.CN(".section-twelfth .fadein-up")) : f(document.querySelectorAll(o.CN(".section-twelfth .list-item-line"))), b(),
                            function(e) {
                                var s, t = document.querySelectorAll(o.CN(".section-fourteenth .video-item")),
                                    i = o(o.CN(".section-fourteenth .tab")),
                                    n = o(o.CN(".section-fourteenth .video-item"));
                                if (t) {
                                    var c = 0;
                                    t[c].querySelector("video").currentTime = 0, R(c), h(c, t, n, i), i.on("click", (function() {
                                        R(c = o(this).index()), t[c].querySelector("video").currentTime = 0, h(c, t, n, i)
                                    })), setInterval((function() {
                                        R(c = (c + 1) % t.length), t[c].querySelector("video"), t[c].querySelector("video").currentTime = 0, h(c, t, n, i)
                                    }), 2e3)
                                }
                                s = p ? document.querySelector(o.CN(".section-fourteenth .container-tb-mob .grid-content")) : document.querySelector(o.CN(".section-fourteenth .container-tb-pc .grid-content"));
                                var r = o.CN(".section-fourteenth .fade-show");
                                gsap.set(o(r), {
                                    opacity: 0
                                }), gsap.fromTo(o(r), {
                                    opacity: 0
                                }, {
                                    opacity: 1,
                                    duration: .5,
                                    ease: "power2.easeOut",
                                    immediateRender: !0,
                                    scrollTrigger: {
                                        trigger: s,
                                        start: "top bottom-=" + (p ? "25%" : "15%"),
                                        end: "top+=50px bottom-=" + (p ? "25%" : "12%"),
                                        invalidateOnRefresh: !0,
                                        toggleActions: "play none resume reverse"
                                    },
                                    delay: Number(o(this).attr("delay")) || 0
                                })
                            }(), j(),
                            function(e) {
                                p && d(o.CN(".section-seventeenth .container-fadein-up-list"));
                                var s = document.querySelector(o.CN(".section-seventeenth .box-item")),
                                    t = (document.querySelector(o.CN(".section-seventeenth .box-item-img")), document.querySelector(o.CN(".section-seventeenth .img-highlight")));
                                gsap.set(s, {
                                    opacity: 0,
                                    y: 60
                                }), gsap.timeline({
                                    yoyo: !0,
                                    defaults: {
                                        duration: 1,
                                        delay: .3,
                                        ease: "power1.inOut"
                                    },
                                    scrollTrigger: {
                                        trigger: s,
                                        start: "top bottom-=" + (p ? "20%" : "15%"),
                                        end: "top+=100px bottom-=" + (p ? "20%" : "15%"),
                                        toggleActions: "play play resume reverse",
                                        scrub: !0,
                                        id: "s17"
                                    }
                                }).fromTo(s, {
                                    opacity: 0,
                                    y: 60
                                }, {
                                    opacity: 1,
                                    y: 0,
                                    delay: .5
                                }, ">").fromTo(t, {
                                    opacity: 0
                                }, {
                                    opacity: 1
                                }, ">")
                            }(), new Swiper("#eighteenthSwiper", r(r(r(r(r({
                                slidesPerView: p ? 1 : 3,
                                centeredSlides: p,
                                grabCursor: !0,
                                loop: !1,
                                pagination: !!p && {
                                    el: ".swiper-pagination-eighteenth",
                                    clickable: !0
                                }
                            }, "slidesPerView", "auto"), "a11y", {
                                slideRole: "listitem"
                            }), "autoplay", !1), "navigation", {
                                nextEl: "#eighteenthSwiperBtNext",
                                prevEl: "#eighteenthSwiperBtPrev"
                            }), "on", {
                                init: function() {
                                    o(o.CN(".section-eighteenth .content-text-mob")).hide(), o(o.CN(".section-eighteenth .content-text-mob")).eq(0).show()
                                },
                                slideChange: function() {
                                    if (p) {
                                        var e = this.activeIndex;
                                        o(o.CN(".section-eighteenth .content-text-mob")).hide(), o(o.CN(".section-eighteenth .content-text-mob")).eq(e).show()
                                    }
                                }
                            })), m(o.CN(".section-nineteenth .fadein-up-list")),
                            function(e) {
                                if (!p) {
                                    var s = document.querySelector(o.CN(".section-twentieth .content-block"));
                                    gsap.timeline({
                                        yoyo: !0,
                                        scrollTrigger: {
                                            trigger: s,
                                            start: "top center",
                                            end: "top+=40% center",
                                            scrub: !0,
                                            id: "s20-1"
                                        }
                                    }).to(s, {
                                        width: "100%",
                                        ease: "power1.out"
                                    })
                                }
                                var t = document.querySelector(o.CN(".section-twentieth .slip-container")),
                                    i = gsap.timeline({
                                        yoyo: !0,
                                        defaults: {
                                            duration: 1,
                                            delay: .2,
                                            ease: "power1.inOut"
                                        },
                                        scrollTrigger: {
                                            trigger: t,
                                            start: "top center",
                                            end: "center center",
                                            toggleActions: "play resume resume reverse",
                                            ease: "power1.inOut",
                                            id: "s21-2"
                                        }
                                    });
                                if (!p) {
                                    var n = document.querySelector(o.CN(".section-twentieth .slip-wrap"));
                                    i.fromTo(n, {
                                        x: "-100%"
                                    }, {
                                        x: 0
                                    }, ">")
                                }
                                document.querySelectorAll(o.CN(".section-twentieth .slip-bubble-box")).forEach((function(e, s) {
                                    i.fromTo(e, {
                                        y: 20,
                                        opacity: 0
                                    }, {
                                        y: 0,
                                        opacity: 1,
                                        duration: .2
                                    }, ">")
                                }))
                            }(), f(document.querySelectorAll(o.CN(".section-twenty-first .list-item-line"))),
                            function() {
                                var e, s = document.querySelector(o.CN(".section-twenty-third .content-text-effect")),
                                    t = document.querySelector(o.CN(".section-twenty-third .title-svg"));
                                p ? (e = document.querySelector(o.CN(".section-twenty-third .title-mob")), m(o.CN(".section-twenty-third .fadein-up-list"))) : (e = document.querySelector(o.CN(".section-twenty-third .title-pc")), d(o.CN(".section-twenty-third .container-fadein-up-list"))), gsap.timeline({
                                    yoyo: !0,
                                    defaults: {
                                        duration: .5,
                                        delay: .1,
                                        ease: "power1.inout",
                                        immediateRender: !0
                                    },
                                    scrollTrigger: {
                                        trigger: s,
                                        start: "top bottom-=25%",
                                        end: "center bottom-=20%",
                                        toggleActions: "play none none reverse",
                                        id: "s23"
                                    }
                                }).to(e, {
                                    onStart: function() {
                                        o(e).addClass("".concat("saros10r_", "active")), o(t).addClass("".concat("saros10r_", "active"))
                                    },
                                    onReverseComplete: function() {
                                        o(e).removeClass("".concat("saros10r_", "active")), o(t).removeClass("".concat("saros10r_", "active"))
                                    }
                                })
                            }(), p && m(o.CN(".section-twenty-fifth .fadein-up-list"))
                    }
            },
            "./src/widgets/Album/index.js": function(e, s, t) {
                "use strict";

                function i() {
                    document.documentElement.clientWidth || window.innerWidth;
                    new Swiper("#qSwiperAlbum", {
                        grabCursor: !0,
                        speed: 2e4,
                        loop: !0,
                        slidesPerView: "auto",
                        a11y: {
                            slideRole: "listitem"
                        },
                        autoplay: {
                            pauseOnMouseEnter: !0,
                            disableOnInteraction: !1,
                            delay: 0
                        }
                    }), new Swiper("#qSwiperAlbum-1", {
                        grabCursor: !0,
                        speed: 16e3,
                        loop: !0,
                        slidesPerView: "auto",
                        a11y: {
                            slideRole: "listitem"
                        },
                        autoplay: {
                            pauseOnMouseEnter: !0,
                            disableOnInteraction: !1,
                            delay: 0
                        }
                    })
                }
                t.d(s, {
                    default: function() {
                        return i
                    }
                })
            },
            "./src/widgets/ClassExtension.js": function(e, s, t) {
                ! function(e) {
                    e.extend({
                        CN: function(e) {
                            return e.startsWith(".") ? e.split(" ").map((function(e) {
                                return e.startsWith(".") ? ".".concat("saros10r_").concat(e.slice(1)) : e
                            })).join(" ") : "saros10r_" + e
                        }
                    })
                }(t("jquery"))
            },
            "./src/widgets/ContrastContainer/index.js": function(e, s, t) {
                "use strict";
                var i = t("jquery");

                function n(e, s) {
                    return function(e) {
                        if (Array.isArray(e)) return e
                    }(e) || function(e, s) {
                        var t = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                        if (null != t) {
                            var i, n, o, c, r = [],
                                a = !0,
                                p = !1;
                            try {
                                if (o = (t = t.call(e)).next, 0 === s) {
                                    if (Object(t) !== t) return;
                                    a = !1
                                } else
                                    for (; !(a = (i = o.call(t)).done) && (r.push(i.value), r.length !== s); a = !0);
                            } catch (e) {
                                p = !0, n = e
                            } finally {
                                try {
                                    if (!a && null != t.return && (c = t.return(), Object(c) !== c)) return
                                } finally {
                                    if (p) throw n
                                }
                            }
                            return r
                        }
                    }(e, s) || function(e, s) {
                        if (!e) return;
                        if ("string" == typeof e) return o(e, s);
                        var t = Object.prototype.toString.call(e).slice(8, -1);
                        "Object" === t && e.constructor && (t = e.constructor.name);
                        if ("Map" === t || "Set" === t) return Array.from(e);
                        if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return o(e, s)
                    }(e, s) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
                    }()
                }

                function o(e, s) {
                    (null == s || s > e.length) && (s = e.length);
                    for (var t = 0, i = new Array(s); t < s; t++) i[t] = e[t];
                    return i
                }
                i((function() {
                    // var e = document.documentElement.clientWidth || window.innerWidth;
                    // (function() {
                    //     var s, t = JSON.parse(document.getElementById("compare_data").text),
                    //         o = (s = t, JSON.parse(JSON.stringify(s)));

                    //     function c(s) {
                    //         var o = "";
                    //         Object.entries(s).forEach((function(s, i) {
                    //             var c = n(s, 2),
                    //                 r = c[0],
                    //                 a = c[1];
                    //             i > (e > 750 ? 2 : 1) || (o += '<div class="'.concat("saros10r_", 'item">\n          <img src="').concat(a.imgsrc, '" alt="').concat(a.name, '">\n          <div class="').concat("saros10r_", 'h4">').concat(a.name, '\n            <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">\n              <path d="M1.5 1L6.5 6L11.5 1" stroke="#DB2D30" stroke-width="2" stroke-linecap="round"/>\n            </svg>\n            <div class="').concat("saros10r_", 'popup">\n              <div class="').concat("saros10r_", 'models">').concat(a.choose, "</div>"), Object.entries(t).forEach((function(e) {
                    //                 var s = n(e, 2),
                    //                     t = s[0],
                    //                     i = s[1];
                    //                 o += '<p class="'.concat("saros10r_", 'modlist" parentlevel="').concat(r, '" productname="').concat(t, '">\n                <svg class="').concat(a.name == i.name ? "".concat("saros10r_", "active") : "", '" width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">\n                  <path d="M1.33346 3L4.33354 6L10.0002 1" stroke="black" stroke-width="1.5" stroke-linecap="round"/>\n                </svg><span>').concat(i.name, "</span></p>")
                    //             })), o += "</div>\n          </div>\n          <div>", a.open_purchase ? o += '<button class="'.concat("saros10r_", 'buy-now purchase-sales-channel-btn" product-name="').concat(a.name.replaceAll(" ", "-").replaceAll("Roborock-", ""), '" data-toggle="modal" data-target="#product-sales-channel">').concat(a.btntext, "</button>") : a.show_link_btn ? o += '<a href="'.concat(a.btn_link, '"><button class="').concat("saros10r_", 'buy-now">').concat(a.btntext, "</button></a>") : o += '<div class="'.concat("saros10r_", 'no_btn"></div>'), o += "</div>\n          <ul>", Object.entries(a).forEach((function(e) {
                    //                 var s = n(e, 2),
                    //                     t = s[0],
                    //                     i = s[1];
                    //                 t.includes("item") && (o += "<li>".concat(i, "</li>"))
                    //             })), o += "</ul>\n        </div>")
                    //         })), i("#compare-table").html(o), "function" == typeof ReloadSalesChannelEvents && ReloadSalesChannelEvents()
                    //     }
                    //     c(t), i(i.CN(".contrast-container")).on("click", i.CN(".h4"), (function() {
                    //         i(this).children(i.CN(".popup")).toggle()
                    //     })), i(document).on("click", (function(e) {
                    //         i(e.target).closest(i.CN(".contrast-container .h4")).length || i(i.CN(".contrast-container .popup")).hide()
                    //     })), i(i.CN(".contrast-container")).on("click", i.CN(".h4 .modlist"), (function(e) {
                    //         var s = i(this).attr("productname"),
                    //             n = i(this).attr("parentlevel");
                    //         o[n] = t[s], c(o)
                    //     }))
                    // })()
                }))
            },
            "./src/widgets/FullScreenVideo/index.js": function(e, s, t) {
                "use strict";
                var i = t("jquery");
                i((function() {
                    function e() {
                        i(i.CN(".full_screen_video")).hide();
                        var e = new window.CustomEvent("hide.all.modals");
                        document.dispatchEvent(e)
                    }! function() {
                        var e = document.querySelectorAll(i.CN(".as-youtube-video"));
                        if (e.length > 0) {
                            var s = document.createElement("script");
                            s.src = "https://www.youtube.com/iframe_api";
                            var t = document.getElementsByTagName("script")[0];
                            t.parentNode.insertBefore(s, t);
                            var n = [],
                                o = function(e) {
                                    document.addEventListener("hide.all.modals", (function(e) {
                                        for (var s = 0; s < n.length; s++) n[s].pauseVideo()
                                    }))
                                };
                            window.onYouTubeIframeAPIReady = function() {
                                for (var s = 0; s < e.length; s++) n.push(new window.YT.Player(e[s], {
                                    events: {
                                        onReady: o
                                    }
                                }))
                            }
                        }
                    }(), i(i.CN(".section-second .content-block .videoBtn")).on("click", (function(e) {
                        i(i.CN(".full_screen_video")).show()
                    })), i(i.CN(".full_screen_video")).on("click", (function(s) {
                        e()
                    })), i(i.CN(".full_screen_video .video-close")).on("click", (function(s) {
                        e()
                    }))
                }))
            },
            "./src/widgets/LeftNav/index.js": function(e, s, t) {
                "use strict";
                t("jquery")
            },
            "./src/widgets/SeriseContainer/index.js": function(e, s, t) {
                "use strict";
                var i = t("jquery");
                i((function() {
                    i("#sideBtn").on("click", (function() {
                        var e = i(i.CN(".serise-container"));
                        e.hasClass(i.CN("show")) ? e.addClass(i.CN("hide")).removeClass(i.CN("show")) : e.addClass(i.CN("show")).removeClass(i.CN("hide"))
                    })), i("#popup-tab").delegate(i.CN(".tabTitle"), "click", (function(e) {
                        i(this).addClass(i.CN("active")).siblings().removeClass(i.CN("active")), i(i.CN(".tabbody .tabCard")).eq(i(this).index()).show().siblings().hide(), i(i.CN(".pc .img")).eq(i(this).index()).addClass(i.CN("active")).siblings().removeClass(i.CN("active")), i(i.CN(".mob .img")).eq(i(this).index()).addClass(i.CN("active")).siblings().removeClass(i.CN("active"))
                    }))
                }))
            },
            "./src/widgets/basics.js": function(e, s, t) {
                "use strict";
                t.d(s, {
                    basics: function() {
                        return n
                    }
                });
                var i = t("jquery");

                function n() {
                    i(".ad-bar").length > 0 && i(i.CN(".container")).css({
                        "margin-top": "110px"
                    }), i("#product_subscription_b").on("click", (function() {
                        i("#subscribe-modal").css({
                            display: "block"
                        })
                    }))
                }
            },
            "./src/widgets/debug.js": function(e, s, t) {
                "use strict";
                t.d(s, {
                    debugfunction: function() {
                        return n
                    }
                });
                var i = t("jquery");

                function n() {
                    var e, s, t, n, o, c, r, a, p = null,
                        g = !1,
                        u = null,
                        _ = null,
                        l = null,
                        m = null;

                    function d() {
                        var e = window.innerWidth,
                            s = window.innerHeight;
                        window.outerWidth, window.outerHeight;
                        p && (p.text("分辨率".concat(e, "*").concat(s)), window.innerWidth > 751 ? (i(u).css("display", "block"), i(_).css("display", "block"), i(l).css("display", "block"), i(m).css("display", "block")) : (i(u).css("display", "none"), i(_).css("display", "none"), i(l).css("display", "none"), i(m).css("display", "none")))
                    }
                    // e = window.location.href, s = new URL(e), t = s.hostname, n = s.searchParams.get("debugResolution"), !(o = /^((25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)$/).test(t) && !/^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|(([0-9a-fA-F]{1,4}:){1,7}|:):(([0-9a-fA-F]{1,4}:){1,7}|:))$/.test(t) && "show" != n || (g || function() {
                    //     (p = i("<div>", {
                    //         id: "resolution-container",
                    //         style: "position:fixed;top:10px;left:10px;z-index:9999999;background-color:rgba(0,0,0,0.6);color:#fff;padding:5px 10px;box-shadow:0 0 10px rgba(0,0,0,0.1);",
                    //         text: "分辨率: 加载中..."
                    //     })).appendTo("body"), g = !0, u = i("<div>", {
                    //         id: "resolution-choose-Title",
                    //         style: "position:fixed;top:10px;left:263px;z-index:9999999;color:#000;padding:5px 10px;",
                    //         text: " 分辨率按钮 => "
                    //     }), _ = i("<a>", {
                    //         id: "resolution-choose1",
                    //         style: "position:fixed;top:10px;left:405px;z-index:9999999;background-color:rgba(0,0,0,0.6);color:#fff;padding:5px 10px;box-shadow:0 0 10px rgba(0,0,0,0.1);border-radius:20px;cursor: pointer;",
                    //         text: "1920*960"
                    //     }), l = i("<a>", {
                    //         id: "resolution-choose2",
                    //         style: "position:fixed;top:10px;left:500px;z-index:9999999;background-color:rgba(0,0,0,0.6);color:#fff;padding:5px 10px;box-shadow:0 0 10px rgba(0,0,0,0.1);border-radius:20px;cursor: pointer;",
                    //         text: "1536*754"
                    //     }), m = i("<a>", {
                    //         id: "resolution-choose3",
                    //         style: "position:fixed;top:10px;left:592px;z-index:9999999;background-color:rgba(0,0,0,0.6);color:#fff;padding:5px 10px;box-shadow:0 0 10px rgba(0,0,0,0.1);border-radius:20px;cursor: pointer;",
                    //         text: "1280*600"
                    //     }), u.appendTo("body"), _.appendTo("body"), l.appendTo("body"), m.appendTo("body");
                    //     var e = window.location.href;
                    //     _.on("click", (function() {
                    //         window.open(e, "_blank", "width=1920,height=961")
                    //     })), l.on("click", (function() {
                    //         window.open(e, "_blank", "width=1536,height=755")
                    //     })), m.on("click", (function() {
                    //         window.open(e, "_blank", "width=1280,height=601")
                    //     }))
                    // }(), d(), o.test(t)), i(window).resize((c = d, r = 200, a = 0, function() {
                    //     var e = (new Date).getTime();
                    //     e - a >= r && (a = e, c.apply(void 0, arguments))
                    // }))
                }
            },
            "./src/widgets/gsap-sequence.js": function(e, s, t) {
                "use strict";
                t.d(s, {
                    imageSequence: function() {
                        return n
                    }
                });
                var i = t("jquery");

                function n(e) {
                    o(i(e.canvas));
                    var s, t = {
                            frame: 0
                        },
                        n = gsap.utils.toArray(e.canvas)[0] || console.warn("canvas not defined"),
                        c = n.getContext("2d"),
                        r = -1,
                        a = e.onUpdate,
                        p = function() {
                            var i = Math.round(t.frame);
                            if (i !== r) {
                                e.clear && c.clearRect(0, 0, n.width, n.height);
                                var o, p, g, u, _ = s[Math.round(t.frame)],
                                    l = _.width / _.height,
                                    m = n.width / n.height;
                                "contain" === e.objectFit ? (l <= m ? (g = l * n.height, u = n.height, o = (n.width - g) / 2, p = 0) : (u = (g = n.width) / l, o = 0, p = (n.height - u) / 2), c.drawImage(_, 0, 0, _.width, _.height, o, p, g, u)) : (l <= m ? (g = _.width, u = _.width / m, o = 0, p = (_.height - u) / 2) : (g = _.height * m, u = _.height, o = (_.width - g) / 2, p = 0), c.drawImage(_, o, p, g, u, 0, 0, n.width, n.height)), r = i, a && a.call(this, i, s[i])
                            }
                        };
                    return window.addEventListener("resize", function(e, s) {
                        var t = null,
                            i = null,
                            n = null;

                        function o() {
                            (n = +new Date) - t < s ? i = setTimeout(o, s) : (e(), i = null), t = n
                        }
                        return function() {
                            t = +new Date, i || (i = setTimeout(o, s))
                        }
                    }((function() {
                        o(i(e.canvas))
                    }), 300), !1), s = e.urls.map((function(e, s) {
                        var t = new Image;
                        return t.src = e, s || (t.onload = p), t
                    })), gsap.to(t, {
                        frame: s.length - 1,
                        ease: "none",
                        onUpdate: p,
                        duration: s.length / (e.fps || 30),
                        paused: !!e.paused,
                        scrollTrigger: e.scrollTrigger,
                        onComplete: e.onComplete,
                        onReverseComplete: e.onReverseComplete
                    })
                }

                function o(e) {
                    var s = e.innerWidth(),
                        t = e.innerHeight(),
                        i = window.devicePixelRatio;
                    e.attr("width", Math.round(s * i)), e.attr("height", Math.round(t * i))
                }
            },
            "./src/widgets/index.js": function(e, s, t) {
                "use strict";
                t("./src/widgets/ContrastContainer/index.js"), t("./src/widgets/FullScreenVideo/index.js"), t("./src/widgets/LeftNav/index.js"), t("./src/widgets/SeriseContainer/index.js"), t("./src/widgets/ClassExtension.js");
                var i = t("./src/widgets/Album/index.js"),
                    n = t("./src/widgets/basics.js");
                (0, i.default)(), (0, n.basics)()
            },
            "./src/index.html": function(e, s, t) {
                "use strict";
                var i = t("./node_modules/html-loader/dist/runtime/getUrl.js"),
                    n = t.n(i),
                    o = new URL(t("./src/assets/video/section1_product_video.mp4"), t.b),
                    c = new URL(t("./src/assets/video/section1_product_video_m.mp4"), t.b),
                    r = new URL(t("./src/assets/images/section2_tuv_m.png"), t.b),
                    a = new URL(t("./src/assets/images/section2_tuv.png"), t.b),
                    p = new URL(t("./src/assets/images/section3_pic1_m.jpg"), t.b),
                    g = new URL(t("./src/assets/images/section3_pic1.jpg"), t.b),
                    u = new URL(t("./src/assets/images/section3_pic2_m.jpg"), t.b),
                    _ = new URL(t("./src/assets/images/section3_pic2.jpg"), t.b),
                    l = new URL(t("./src/assets/images/section3_pic3_m.jpg"), t.b),
                    m = new URL(t("./src/assets/images/section3_pic3.jpg"), t.b),
                    d = new URL(t("./src/assets/images/section3_pic4_m.jpg"), t.b),
                    f = new URL(t("./src/assets/images/section3_pic4.jpg"), t.b),
                    w = new URL(t("./src/assets/images/section3_pic5_m.jpg"), t.b),
                    v = new URL(t("./src/assets/images/section3_pic5.jpg"), t.b),
                    b = new URL(t("./src/assets/images/section3_pic6_m.jpg"), t.b),
                    R = new URL(t("./src/assets/images/section3_pic6.jpg"), t.b),
                    h = new URL(t("./src/assets/images/section3_pic7_m.jpg"), t.b),
                    x = new URL(t("./src/assets/images/section3_pic7.jpg"), t.b),
                    j = new URL(t("./src/assets/images/section3_pic8_m.jpg"), t.b),
                    S = new URL(t("./src/assets/images/section3_pic8.jpg"), t.b),
                    y = new URL(t("./src/assets/images/section4_saros.jpg"), t.b),
                    C = new URL(t("./src/assets/images/section4_expand_kv_m.png"), t.b),
                    L = new URL(t("./src/assets/images/section4_expand_kv.png"), t.b),
                    U = new URL(t("./src/assets/images/section4_expand1.jpg"), t.b),
                    N = new URL(t("./src/assets/images/section4_expand2_m.jpg"), t.b),
                    k = new URL(t("./src/assets/images/section4_expand2.jpg"), t.b),
                    q = new URL(t("./src/assets/images/section4expand_icon1.png"), t.b),
                    T = new URL(t("./src/assets/images/section4expand_icon2.png"), t.b),
                    A = new URL(t("./src/assets/images/section4expand_icon3.png"), t.b),
                    O = new URL(t("./src/assets/images/section4_expand3.jpg"), t.b),
                    E = new URL(t("./src/assets/images/section5_pic_m.jpg"), t.b),
                    I = new URL(t("./src/assets/images/section6_dark_m.jpg"), t.b),
                    P = new URL(t("./src/assets/images/section6_dark.jpg"), t.b),
                    B = new URL(t("./src/assets/images/section6_highlight_m.jpg"), t.b),
                    M = new URL(t("./src/assets/images/section6_highlight.jpg"), t.b),
                    W = new URL(t("./src/assets/video/section6_video1.mp4"), t.b),
                    z = new URL(t("./src/assets/video/section6_video1_m.mp4"), t.b),
                    H = new URL(t("./src/assets/video/section6_video2.mp4"), t.b),
                    F = new URL(t("./src/assets/video/section6_video2_m.mp4"), t.b),
                    V = new URL(t("./src/assets/video/section7_video.mp4"), t.b),
                    X = new URL(t("./src/assets/video/section7_video_m.mp4"), t.b),
                    D = new URL(t("./src/assets/images/section8_swiper1_m.jpg"), t.b),
                    Y = new URL(t("./src/assets/images/section8_swiper1.jpg"), t.b),
                    $ = new URL(t("./src/assets/images/section8_swiper2_m.jpg"), t.b),
                    J = new URL(t("./src/assets/images/section8_swiper2.jpg"), t.b),
                    Q = new URL(t("./src/assets/images/section8_swiper3_m.jpg"), t.b),
                    G = new URL(t("./src/assets/images/section8_swiper3.jpg"), t.b),
                    K = new URL(t("./src/assets/images/section8_swiper4_m.jpg"), t.b),
                    Z = new URL(t("./src/assets/images/section8_swiper4.jpg"), t.b),
                    ee = new URL(t("./src/assets/images/section8_swiper5_m.jpg"), t.b),
                    se = new URL(t("./src/assets/images/section8_swiper5.jpg"), t.b),
                    te = new URL(t("./src/assets/images/section9_invisible_m.png"), t.b),
                    ie = new URL(t("./src/assets/images/section9_invisible.png"), t.b),
                    ne = new URL(t("./src/assets/images/section9_visible_m.png"), t.b),
                    oe = new URL(t("./src/assets/images/section9_visible.png"), t.b),
                    ce = new URL(t("./src/assets/images/section9_tuv0_m.png"), t.b),
                    re = new URL(t("./src/assets/images/section9_tuv1_m.png"), t.b),
                    ae = new URL(t("./src/assets/images/section9_tuv2_m.png"), t.b),
                    pe = new URL(t("./src/assets/video/section10_video1.mp4"), t.b),
                    ge = new URL(t("./src/assets/video/section10_video1_m.mp4"), t.b),
                    ue = new URL(t("./src/assets/images/section10_tuv1.png"), t.b),
                    _e = new URL(t("./src/assets/images/section10_tuv2.png"), t.b),
                    le = new URL(t("./src/assets/images/section10_tuv3.png"), t.b),
                    me = new URL(t("./src/assets/video/section10_video2.mp4"), t.b),
                    de = new URL(t("./src/assets/video/section10_video2_m.mp4"), t.b),
                    fe = new URL(t("./src/assets/images/section10_side_tuv1.png"), t.b),
                    we = new URL(t("./src/assets/images/section10_side_tuv2.png"), t.b),
                    ve = new URL(t("./src/assets/images/section11_wheel_m.png"), t.b),
                    be = new URL(t("./src/assets/images/section11_wheel.png"), t.b),
                    Re = new URL(t("./src/assets/images/section11_power_m.jpg"), t.b),
                    he = new URL(t("./src/assets/images/section11_power.jpg"), t.b),
                    xe = new URL(t("./src/assets/video/section12_video.mp4"), t.b),
                    je = new URL(t("./src/assets/video/section12_video_m.mp4"), t.b),
                    Se = new URL(t("./src/assets/images/section12_tuv.png"), t.b),
                    ye = new URL(t("./src/assets/video/section13_saros_video.mp4"), t.b),
                    Ce = new URL(t("./src/assets/video/section13_video1.mp4"), t.b),
                    Le = new URL(t("./src/assets/video/section13_video1_m.mp4"), t.b),
                    Ue = new URL(t("./src/assets/video/section13_video2.mp4"), t.b),
                    Ne = new URL(t("./src/assets/video/section13_video2_m.mp4"), t.b),
                    ke = new URL(t("./src/assets/video/section13_video3.mp4"), t.b),
                    qe = new URL(t("./src/assets/video/section13_video3_m.mp4"), t.b),
                    Te = new URL(t("./src/assets/video/section14_video1.mp4"), t.b),
                    Ae = new URL(t("./src/assets/video/section14_video2.mp4"), t.b),
                    Oe = new URL(t("./src/assets/video/section14_video3.mp4"), t.b),
                    Ee = new URL(t("./src/assets/video/section14_video4.mp4"), t.b),
                    Ie = new URL(t("./src/assets/video/section15_video.mp4"), t.b),
                    Pe = new URL(t("./src/assets/video/section16_video.mp4"), t.b),
                    Be = new URL(t("./src/assets/images/section16_icon1.png"), t.b),
                    Me = new URL(t("./src/assets/images/section16_icon2.png"), t.b),
                    We = new URL(t("./src/assets/images/section16_icon3.png"), t.b),
                    ze = new URL(t("./src/assets/images/section16_icon4.png"), t.b),
                    He = new URL(t("./src/assets/images/section16_icon5.png"), t.b),
                    Fe = new URL(t("./src/assets/images/section16_icon6.png"), t.b),
                    Ve = new URL(t("./src/assets/images/section16_icon7.png"), t.b),
                    Xe = new URL(t("./src/assets/images/section16_icon8.png"), t.b),
                    De = new URL(t("./src/assets/images/section16_icon9.png"), t.b),
                    Ye = new URL(t("./src/assets/images/section16_icon10.png"), t.b),
                    $e = new URL(t("./src/assets/images/section17_pic.jpg"), t.b),
                    Je = new URL(t("./src/assets/images/section17_point_dark_m.png"), t.b),
                    Qe = new URL(t("./src/assets/images/section17_point_dark.png"), t.b),
                    Ge = new URL(t("./src/assets/images/section17_point_m.png"), t.b),
                    Ke = new URL(t("./src/assets/images/section17_point.png"), t.b),
                    Ze = new URL(t("./src/assets/images/section18_swiper1_m.jpg"), t.b),
                    es = new URL(t("./src/assets/images/section18_swiper1.jpg"), t.b),
                    ss = new URL(t("./src/assets/images/section18_swiper2_m.jpg"), t.b),
                    ts = new URL(t("./src/assets/images/section18_swiper2.jpg"), t.b),
                    is = new URL(t("./src/assets/images/section18_swiper3_m.jpg"), t.b),
                    ns = new URL(t("./src/assets/images/section18_swiper3.jpg"), t.b),
                    os = new URL(t("./src/assets/images/section18_swiper4_m.jpg"), t.b),
                    cs = new URL(t("./src/assets/images/section18_swiper4.jpg"), t.b),
                    rs = new URL(t("./src/assets/images/section18_swiper5_m.jpg"), t.b),
                    as = new URL(t("./src/assets/images/section18_swiper5.jpg"), t.b),
                    ps = new URL(t("./src/assets/images/section18_swiper6_m.jpg"), t.b),
                    gs = new URL(t("./src/assets/images/section18_swiper6.jpg"), t.b),
                    us = new URL(t("./src/assets/images/section18_swiper7_m.jpg"), t.b),
                    _s = new URL(t("./src/assets/images/section18_swiper7.jpg"), t.b),
                    ls = new URL(t("./src/assets/images/section18_swiper8_m.jpg"), t.b),
                    ms = new URL(t("./src/assets/images/section18_swiper8.jpg"), t.b),
                    ds = new URL(t("./src/assets/images/section19_say_m.jpg"), t.b),
                    fs = new URL(t("./src/assets/images/section19_say.jpg"), t.b),
                    ws = new URL(t("./src/assets/images/section19_icon1.png"), t.b),
                    vs = new URL(t("./src/assets/images/section19_icon2.png"), t.b),
                    bs = new URL(t("./src/assets/images/section19_icon3.png"), t.b),
                    Rs = new URL(t("./src/assets/images/section19_icon4.png"), t.b),
                    hs = new URL(t("./src/assets/images/section19_icon5.png"), t.b),
                    xs = new URL(t("./src/assets/images/section19_icon6.png"), t.b),
                    js = new URL(t("./src/assets/images/section20_iphone.png"), t.b),
                    Ss = new URL(t("./src/assets/images/section20_color.gif"), t.b),
                    ys = new URL(t("./src/assets/images/section20_pic_m.jpg"), t.b),
                    Cs = new URL(t("./src/assets/images/section20_pic.jpg"), t.b),
                    Ls = new URL(t("./src/assets/images/section20_box_m.png"), t.b),
                    Us = new URL(t("./src/assets/images/section20_box.png"), t.b),
                    Ns = new URL(t("./src/assets/images/section22_pic.jpg"), t.b),
                    ks = new URL(t("./src/assets/images/section23_cat.png"), t.b),
                    qs = new URL(t("./src/assets/video/section23_video.mp4"), t.b),
                    Ts = new URL(t("./src/assets/video/section23_video_m.mp4"), t.b),
                    As = new URL(t("./src/assets/images/section23_pic2_m.jpg"), t.b),
                    Os = new URL(t("./src/assets/images/section23_pic2.jpg"), t.b),
                    Es = new URL(t("./src/assets/images/section23_pic3_m.jpg"), t.b),
                    Is = new URL(t("./src/assets/images/section23_pic3.jpg"), t.b),
                    Ps = new URL(t("./src/assets/images/section23_pic4_m.png"), t.b),
                    Bs = new URL(t("./src/assets/images/section23_pic4.png"), t.b),
                    Ms = new URL(t("./src/assets/images/section24_pic_m.jpg"), t.b),
                    Ws = new URL(t("./src/assets/images/section24_pic.jpg"), t.b),
                    zs = new URL(t("./src/assets/images/section25_pic1.jpg"), t.b),
                    Hs = new URL(t("./src/assets/images/section25_pic2.jpg"), t.b),
                    Fs = new URL(t("./src/assets/images/section25_pic3.jpg"), t.b),
                    Vs = new URL(t("./src/assets/images/album_pic1.jpg"), t.b),
                    Xs = new URL(t("./src/assets/images/album_pic2.jpg"), t.b),
                    Ds = new URL(t("./src/assets/images/album_pic3.jpg"), t.b),
                    Ys = new URL(t("./src/assets/images/album_pic4.jpg"), t.b),
                    $s = new URL(t("./src/assets/images/album_pic5.jpg"), t.b),
                    Js = new URL(t("./src/assets/images/album_pic6.jpg"), t.b),
                    Qs = new URL(t("./src/assets/images/album_pic7.jpg"), t.b),
                    Gs = new URL(t("./src/assets/images/album_pic8.jpg"), t.b),
                    Ks = new URL(t("./src/assets/images/album_pic9.jpg"), t.b),
                    Zs = new URL(t("./src/assets/images/album_pic10.jpg"), t.b),
                    et = new URL(t("./src/assets/images/album_pic11.jpg"), t.b),
                    st = new URL(t("./src/assets/images/album_pic12.jpg"), t.b),
                    tt = new URL(t("./src/assets/images/section53_waterbox.png"), t.b),
                    it = new URL(t("./src/assets/images/section53_size.png"), t.b),
                    nt = new URL(t("./src/assets/images/saros_10r.png"), t.b),
                    ot = new URL(t("./src/assets/images/saros_10.png"), t.b),
                    ct = n()(o),
                    rt = n()(c),
                    at = n()(r),
                    pt = n()(a),
                    gt = n()(p),
                    ut = n()(g),
                    _t = n()(u),
                    lt = n()(_),
                    mt = n()(l),
                    dt = n()(m),
                    ft = n()(d),
                    wt = n()(f),
                    vt = n()(w),
                    bt = n()(v),
                    Rt = n()(b),
                    ht = n()(R),
                    xt = n()(h),
                    jt = n()(x),
                    St = n()(j),
                    yt = n()(S),
                    Ct = n()(y),
                    Lt = n()(C),
                    Ut = n()(L),
                    Nt = n()(U),
                    kt = n()(N),
                    qt = n()(k),
                    Tt = n()(q),
                    At = n()(T),
                    Ot = n()(A),
                    Et = n()(O),
                    It = n()(E),
                    Pt = n()(I),
                    Bt = n()(P),
                    Mt = n()(B),
                    Wt = n()(M),
                    zt = n()(W),
                    Ht = n()(z),
                    Ft = n()(H),
                    Vt = n()(F),
                    Xt = n()(V),
                    Dt = n()(X),
                    Yt = n()(D),
                    $t = n()(Y),
                    Jt = n()($),
                    Qt = n()(J),
                    Gt = n()(Q),
                    Kt = n()(G),
                    Zt = n()(K),
                    ei = n()(Z),
                    si = n()(ee),
                    ti = n()(se),
                    ii = n()(te),
                    ni = n()(ie),
                    oi = n()(ne),
                    ci = n()(oe),
                    ri = n()(ce),
                    ai = n()(re),
                    pi = n()(ae),
                    gi = n()(pe),
                    ui = n()(ge),
                    _i = n()(ue),
                    li = n()(_e),
                    mi = n()(le),
                    di = n()(me),
                    fi = n()(de),
                    wi = n()(fe),
                    vi = n()(we),
                    bi = n()(ve),
                    Ri = n()(be),
                    hi = n()(Re),
                    xi = n()(he),
                    ji = n()(xe),
                    Si = n()(je),
                    yi = n()(Se),
                    Ci = n()(ye),
                    Li = n()(Ce),
                    Ui = n()(Le),
                    Ni = n()(Ue),
                    ki = n()(Ne),
                    qi = n()(ke),
                    Ti = n()(qe),
                    Ai = n()(Te),
                    Oi = n()(Ae),
                    Ei = n()(Oe),
                    Ii = n()(Ee),
                    Pi = n()(Ie),
                    Bi = n()(Pe),
                    Mi = n()(Be),
                    Wi = n()(Me),
                    zi = n()(We),
                    Hi = n()(ze),
                    Fi = n()(He),
                    Vi = n()(Fe),
                    Xi = n()(Ve),
                    Di = n()(Xe),
                    Yi = n()(De),
                    $i = n()(Ye),
                    Ji = n()($e),
                    Qi = n()(Je),
                    Gi = n()(Qe),
                    Ki = n()(Ge),
                    Zi = n()(Ke),
                    en = n()(Ze),
                    sn = n()(es),
                    tn = n()(ss),
                    nn = n()(ts),
                    on = n()(is),
                    cn = n()(ns),
                    rn = n()(os),
                    an = n()(cs),
                    pn = n()(rs),
                    gn = n()(as),
                    un = n()(ps),
                    _n = n()(gs),
                    ln = n()(us),
                    mn = n()(_s),
                    dn = n()(ls),
                    fn = n()(ms),
                    wn = n()(ds),
                    vn = n()(fs),
                    bn = n()(ws),
                    Rn = n()(vs),
                    hn = n()(bs),
                    xn = n()(Rs),
                    jn = n()(hs),
                    Sn = n()(xs),
                    yn = n()(js),
                    Cn = n()(Ss),
                    Ln = n()(ys),
                    Un = n()(Cs),
                    Nn = n()(Ls),
                    kn = n()(Us),
                    qn = n()(Ns),
                    Tn = n()(ks),
                    An = n()(qs),
                    On = n()(Ts),
                    En = n()(As),
                    In = n()(Os),
                    Pn = n()(Es),
                    Bn = n()(Is),
                    Mn = n()(Ps),
                    Wn = n()(Bs),
                    zn = n()(Ms),
                    Hn = n()(Ws),
                    Fn = n()(zs),
                    Vn = n()(Hs),
                    Xn = n()(Fs),
                    Dn = n()(Vs),
                    Yn = n()(Xs),
                    $n = n()(Ds),
                    Jn = n()(Ys),
                    Qn = n()($s),
                    Gn = n()(Js),
                    Kn = n()(Qs),
                    Zn = n()(Gs),
                    eo = n()(Ks),
                    so = n()(Zs),
                    to = n()(et),
                    io = n()(st),
                    no = n()(tt),
                    oo = n()(it);
                n()(nt), n()(ot)
            },
            "./node_modules/html-loader/dist/runtime/getUrl.js": function(e) {
                "use strict";
                e.exports = function(e, s) {
                    return s || (s = {}), e ? (e = String(e.__esModule ? e.default : e), s.hash && (e += s.hash), s.maybeNeedQuotes && /[\t\n\f\r "'=<>`]/.test(e) ? '"'.concat(e, '"') : e) : e
                }
            },
            "./src/assets/images/album_pic1.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_album_pic1.jpg"
            },
            "./src/assets/images/album_pic10.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_album_pic10.jpg"
            },
            "./src/assets/images/album_pic11.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_album_pic11.jpg"
            },
            "./src/assets/images/album_pic12.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_album_pic12.jpg"
            },
            "./src/assets/images/album_pic2.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_album_pic2.jpg"
            },
            "./src/assets/images/album_pic3.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_album_pic3.jpg"
            },
            "./src/assets/images/album_pic4.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_album_pic4.jpg"
            },
            "./src/assets/images/album_pic5.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_album_pic5.jpg"
            },
            "./src/assets/images/album_pic6.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_album_pic6.jpg"
            },
            "./src/assets/images/album_pic7.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_album_pic7.jpg"
            },
            "./src/assets/images/album_pic8.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_album_pic8.jpg"
            },
            "./src/assets/images/album_pic9.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_album_pic9.jpg"
            },
            "./src/assets/images/saros_10.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_saros_10.png"
            },
            "./src/assets/images/saros_10r.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_saros_10r.png"
            },
            "./src/assets/images/section10_side_tuv1.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section10_side_tuv1.png"
            },
            "./src/assets/images/section10_side_tuv2.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section10_side_tuv2.png"
            },
            "./src/assets/images/section10_tuv1.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section10_tuv1.png"
            },
            "./src/assets/images/section10_tuv2.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section10_tuv2.png"
            },
            "./src/assets/images/section10_tuv3.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section10_tuv3.png"
            },
            "./src/assets/images/section11_power.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section11_power.jpg"
            },
            "./src/assets/images/section11_power_m.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section11_power_m.jpg"
            },
            "./src/assets/images/section11_wheel.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section11_wheel.png"
            },
            "./src/assets/images/section11_wheel_m.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section11_wheel_m.png"
            },
            "./src/assets/images/section12_tuv.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section12_tuv.png"
            },
            "./src/assets/images/section16_icon1.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section16_icon1.png"
            },
            "./src/assets/images/section16_icon10.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section16_icon10.png"
            },
            "./src/assets/images/section16_icon2.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section16_icon2.png"
            },
            "./src/assets/images/section16_icon3.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section16_icon3.png"
            },
            "./src/assets/images/section16_icon4.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section16_icon4.png"
            },
            "./src/assets/images/section16_icon5.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section16_icon5.png"
            },
            "./src/assets/images/section16_icon6.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section16_icon6.png"
            },
            "./src/assets/images/section16_icon7.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section16_icon7.png"
            },
            "./src/assets/images/section16_icon8.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section16_icon8.png"
            },
            "./src/assets/images/section16_icon9.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section16_icon9.png"
            },
            "./src/assets/images/section17_pic.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section17_pic.jpg"
            },
            "./src/assets/images/section17_point.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section17_point.png"
            },
            "./src/assets/images/section17_point_dark.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section17_point_dark.png"
            },
            "./src/assets/images/section17_point_dark_m.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section17_point_dark_m.png"
            },
            "./src/assets/images/section17_point_m.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section17_point_m.png"
            },
            "./src/assets/images/section18_swiper1.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section18_swiper1.jpg"
            },
            "./src/assets/images/section18_swiper1_m.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section18_swiper1_m.jpg"
            },
            "./src/assets/images/section18_swiper2.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section18_swiper2.jpg"
            },
            "./src/assets/images/section18_swiper2_m.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section18_swiper2_m.jpg"
            },
            "./src/assets/images/section18_swiper3.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section18_swiper3.jpg"
            },
            "./src/assets/images/section18_swiper3_m.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section18_swiper3_m.jpg"
            },
            "./src/assets/images/section18_swiper4.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section18_swiper4.jpg"
            },
            "./src/assets/images/section18_swiper4_m.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section18_swiper4_m.jpg"
            },
            "./src/assets/images/section18_swiper5.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section18_swiper5.jpg"
            },
            "./src/assets/images/section18_swiper5_m.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section18_swiper5_m.jpg"
            },
            "./src/assets/images/section18_swiper6.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section18_swiper6.jpg"
            },
            "./src/assets/images/section18_swiper6_m.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section18_swiper6_m.jpg"
            },
            "./src/assets/images/section18_swiper7.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section18_swiper7.jpg"
            },
            "./src/assets/images/section18_swiper7_m.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section18_swiper7_m.jpg"
            },
            "./src/assets/images/section18_swiper8.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section18_swiper8.jpg"
            },
            "./src/assets/images/section18_swiper8_m.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section18_swiper8_m.jpg"
            },
            "./src/assets/images/section19_icon1.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section19_icon1.png"
            },
            "./src/assets/images/section19_icon2.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section19_icon2.png"
            },
            "./src/assets/images/section19_icon3.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section19_icon3.png"
            },
            "./src/assets/images/section19_icon4.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section19_icon4.png"
            },
            "./src/assets/images/section19_icon5.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section19_icon5.png"
            },
            "./src/assets/images/section19_icon6.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section19_icon6.png"
            },
            "./src/assets/images/section19_say.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section19_say.jpg"
            },
            "./src/assets/images/section19_say_m.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section19_say_m.jpg"
            },
            "./src/assets/images/section20_box.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section20_box.png"
            },
            "./src/assets/images/section20_box_m.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section20_box_m.png"
            },
            "./src/assets/images/section20_color.gif": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section20_color.gif"
            },
            "./src/assets/images/section20_iphone.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section20_iphone.png"
            },
            "./src/assets/images/section20_pic.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section20_pic.jpg"
            },
            "./src/assets/images/section20_pic_m.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section20_pic_m.jpg"
            },
            "./src/assets/images/section22_pic.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section22_pic.jpg"
            },
            "./src/assets/images/section23_cat.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section23_cat.png"
            },
            "./src/assets/images/section23_pic2.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section23_pic2.jpg"
            },
            "./src/assets/images/section23_pic2_m.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section23_pic2_m.jpg"
            },
            "./src/assets/images/section23_pic3.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section23_pic3.jpg"
            },
            "./src/assets/images/section23_pic3_m.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section23_pic3_m.jpg"
            },
            "./src/assets/images/section23_pic4.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section23_pic4.png"
            },
            "./src/assets/images/section23_pic4_m.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section23_pic4_m.png"
            },
            "./src/assets/images/section24_pic.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section24_pic.jpg"
            },
            "./src/assets/images/section24_pic_m.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section24_pic_m.jpg"
            },
            "./src/assets/images/section25_pic1.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section25_pic1.jpg"
            },
            "./src/assets/images/section25_pic2.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section25_pic2.jpg"
            },
            "./src/assets/images/section25_pic3.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section25_pic3.jpg"
            },
            "./src/assets/images/section2_tuv.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section2_tuv.png"
            },
            "./src/assets/images/section2_tuv_m.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section2_tuv_m.png"
            },
            "./src/assets/images/section3_pic1.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section3_pic1.jpg"
            },
            "./src/assets/images/section3_pic1_m.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section3_pic1_m.jpg"
            },
            "./src/assets/images/section3_pic2.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section3_pic2.jpg"
            },
            "./src/assets/images/section3_pic2_m.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section3_pic2_m.jpg"
            },
            "./src/assets/images/section3_pic3.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section3_pic3.jpg"
            },
            "./src/assets/images/section3_pic3_m.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section3_pic3_m.jpg"
            },
            "./src/assets/images/section3_pic4.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section3_pic4.jpg"
            },
            "./src/assets/images/section3_pic4_m.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section3_pic4_m.jpg"
            },
            "./src/assets/images/section3_pic5.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section3_pic5.jpg"
            },
            "./src/assets/images/section3_pic5_m.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section3_pic5_m.jpg"
            },
            "./src/assets/images/section3_pic6.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section3_pic6.jpg"
            },
            "./src/assets/images/section3_pic6_m.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section3_pic6_m.jpg"
            },
            "./src/assets/images/section3_pic7.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section3_pic7.jpg"
            },
            "./src/assets/images/section3_pic7_m.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section3_pic7_m.jpg"
            },
            "./src/assets/images/section3_pic8.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section3_pic8.jpg"
            },
            "./src/assets/images/section3_pic8_m.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section3_pic8_m.jpg"
            },
            "./src/assets/images/section4_expand1.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section4_expand1.jpg"
            },
            "./src/assets/images/section4_expand2.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section4_expand2.jpg"
            },
            "./src/assets/images/section4_expand2_m.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section4_expand2_m.jpg"
            },
            "./src/assets/images/section4_expand3.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section4_expand3.jpg"
            },
            "./src/assets/images/section4_expand_kv.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section4_expand_kv.png"
            },
            "./src/assets/images/section4_expand_kv_m.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section4_expand_kv_m.png"
            },
            "./src/assets/images/section4_saros.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section4_saros.jpg"
            },
            "./src/assets/images/section4expand_icon1.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section4expand_icon1.png"
            },
            "./src/assets/images/section4expand_icon2.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section4expand_icon2.png"
            },
            "./src/assets/images/section4expand_icon3.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section4expand_icon3.png"
            },
            "./src/assets/images/section53_size.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section53_size.png"
            },
            "./src/assets/images/section53_waterbox.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section53_waterbox.png"
            },
            "./src/assets/images/section5_pic_m.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section5_pic_m.jpg"
            },
            "./src/assets/images/section6_dark.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section6_dark.jpg"
            },
            "./src/assets/images/section6_dark_m.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section6_dark_m.jpg"
            },
            "./src/assets/images/section6_highlight.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section6_highlight.jpg"
            },
            "./src/assets/images/section6_highlight_m.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section6_highlight_m.jpg"
            },
            "./src/assets/images/section8_swiper1.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section8_swiper1.jpg"
            },
            "./src/assets/images/section8_swiper1_m.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section8_swiper1_m.jpg"
            },
            "./src/assets/images/section8_swiper2.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section8_swiper2.jpg"
            },
            "./src/assets/images/section8_swiper2_m.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section8_swiper2_m.jpg"
            },
            "./src/assets/images/section8_swiper3.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section8_swiper3.jpg"
            },
            "./src/assets/images/section8_swiper3_m.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section8_swiper3_m.jpg"
            },
            "./src/assets/images/section8_swiper4.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section8_swiper4.jpg"
            },
            "./src/assets/images/section8_swiper4_m.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section8_swiper4_m.jpg"
            },
            "./src/assets/images/section8_swiper5.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section8_swiper5.jpg"
            },
            "./src/assets/images/section8_swiper5_m.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section8_swiper5_m.jpg"
            },
            "./src/assets/images/section9_invisible.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section9_invisible.png"
            },
            "./src/assets/images/section9_invisible_m.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section9_invisible_m.png"
            },
            "./src/assets/images/section9_tuv0_m.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section9_tuv0_m.png"
            },
            "./src/assets/images/section9_tuv1_m.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section9_tuv1_m.png"
            },
            "./src/assets/images/section9_tuv2_m.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section9_tuv2_m.png"
            },
            "./src/assets/images/section9_visible.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section9_visible.png"
            },
            "./src/assets/images/section9_visible_m.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section9_visible_m.png"
            },
            "./src/assets/video/section10_video1.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section10_video1.mp4"
            },
            "./src/assets/video/section10_video1_m.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section10_video1_m.mp4"
            },
            "./src/assets/video/section10_video2.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section10_video2.mp4"
            },
            "./src/assets/video/section10_video2_m.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section10_video2_m.mp4"
            },
            "./src/assets/video/section12_video.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section12_video.mp4"
            },
            "./src/assets/video/section12_video_m.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section12_video_m.mp4"
            },
            "./src/assets/video/section13_saros_video.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section13_saros_video.mp4"
            },
            "./src/assets/video/section13_video1.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section13_video1.mp4"
            },
            "./src/assets/video/section13_video1_m.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section13_video1_m.mp4"
            },
            "./src/assets/video/section13_video2.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section13_video2.mp4"
            },
            "./src/assets/video/section13_video2_m.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section13_video2_m.mp4"
            },
            "./src/assets/video/section13_video3.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section13_video3.mp4"
            },
            "./src/assets/video/section13_video3_m.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section13_video3_m.mp4"
            },
            "./src/assets/video/section14_video1.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section14_video1.mp4"
            },
            "./src/assets/video/section14_video2.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section14_video2.mp4"
            },
            "./src/assets/video/section14_video3.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section14_video3.mp4"
            },
            "./src/assets/video/section14_video4.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section14_video4.mp4"
            },
            "./src/assets/video/section15_video.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section15_video.mp4"
            },
            "./src/assets/video/section16_video.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section16_video.mp4"
            },
            "./src/assets/video/section1_product_video.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section1_product_video.mp4"
            },
            "./src/assets/video/section1_product_video_m.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section1_product_video_m.mp4"
            },
            "./src/assets/video/section23_video.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section23_video.mp4"
            },
            "./src/assets/video/section23_video_m.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section23_video_m.mp4"
            },
            "./src/assets/video/section6_video1.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section6_video1.mp4"
            },
            "./src/assets/video/section6_video1_m.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section6_video1_m.mp4"
            },
            "./src/assets/video/section6_video2.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section6_video2.mp4"
            },
            "./src/assets/video/section6_video2_m.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section6_video2_m.mp4"
            },
            "./src/assets/video/section7_video.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section7_video.mp4"
            },
            "./src/assets/video/section7_video_m.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/saros10r_section7_video_m.mp4"
            },
            jquery: function(e) {
                "use strict";
                e.exports = $
            }
        },
        s = {};

    function t(i) {
        var n = s[i];
        if (void 0 !== n) return n.exports;
        var o = s[i] = {
            exports: {}
        };
        return e[i](o, o.exports, t), o.exports
    }
    t.m = e, t.n = function(e) {
            var s = e && e.__esModule ? function() {
                return e.default
            } : function() {
                return e
            };
            return t.d(s, {
                a: s
            }), s
        }, t.d = function(e, s) {
            for (var i in s) t.o(s, i) && !t.o(e, i) && Object.defineProperty(e, i, {
                enumerable: !0,
                get: s[i]
            })
        }, t.o = function(e, s) {
            return Object.prototype.hasOwnProperty.call(e, s)
        }, t.p = "/cdn/shop/", t.b = document.baseURI || self.location.href,
        function() {
            "use strict";
            t("./src/index.html"), t("./src/widgets/index.js"), t("./src/js/main.js")
        }()
}();